module.exports = __webpack_public_path__ + "img/202505_08.af1e6df3.jpg";